/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_HeadingInputs */

const tr_onbilgi_s10_heading = /** @type {(inputs: Onbilgi_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Teknik Koruma Önlemleri ve Veri Güvenliği`)
};

const en_onbilgi_s10_heading = /** @type {(inputs: Onbilgi_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Technical Protection Measures and Data Security`)
};

const de_onbilgi_s10_heading = /** @type {(inputs: Onbilgi_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Technische Schutzmaßnahmen und Datensicherheit`)
};

const ru_onbilgi_s10_heading = /** @type {(inputs: Onbilgi_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Технические меры защиты и безопасность данных`)
};

/**
* | output |
* | --- |
* | "10. Technical Protection Measures and Data Security" |
*
* @param {Onbilgi_S10_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_heading = /** @type {((inputs?: Onbilgi_S10_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_heading(inputs)
	if (locale === "de") return de_onbilgi_s10_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s10_heading(inputs)
	return tr_onbilgi_s10_heading(inputs)
});